import React from "react";
import { connect } from "react-redux";
import {
  IonToolbar,
  IonIcon,
  IonButtons,
  IonButton,
  IonHeader,
  IonMenuButton,
  IonTitle,
} from "@ionic/react";
import { useHistory } from "react-router-dom";

import { arrowBack, swapVerticalOutline, alertCircle } from "ionicons/icons";

interface Props {
  title: any;
  wsStatus?: string;
}

const AppHeader: React.FC<Props> = ({ title, wsStatus }) => {
  const history = useHistory();

  const _historyBack = () => {
    history.goBack();
  };

  return (
    <IonHeader>
      <IonToolbar color="primary" id="header">
        <IonButtons slot="start">
          {history.location.pathname !== "/dashboard" &&
            history.location.pathname !== "/" && (
              <IonButton onClick={_historyBack}>
                <IonIcon icon={arrowBack}></IonIcon>
              </IonButton>
            )}
        </IonButtons>
        <IonTitle>{title}</IonTitle>
        <span slot="end" style={{marginRight: "20px", position: "relative"}}>
          <IonIcon  icon={swapVerticalOutline} size="large" style={{ color: `${wsStatus === "connected" ? "white" : "gray"}` }}/>
          {wsStatus === "disconnected" && <IonIcon icon={alertCircle} style={{ color: "red", position: "absolute", top: "0", right: "0", fontWeight: "bold" }}/>}
        </span>
        <IonButtons slot="end">
          <IonMenuButton></IonMenuButton>
        </IonButtons>
      </IonToolbar>
    </IonHeader>
  );
};

const mapStateToProps = (state: any) => ({
  wsStatus: state.general.wsStatus
});

export default connect(mapStateToProps, {})(AppHeader);
